import React, { useState, useEffect } from 'react';
import '../../common.css';
import { getLOLPUser } from "../../services/userApi";
import { getAccessToken } from "../../services/authApi";
import { logError } from "../../utils/logError"; 
import Loading from "../layout/Loading";
import { info, error as logAppInsightError } from '../../utils/logger';
 
const NMLSVerification = () => {
    const [searchText, setSearchText] = useState('');
    const [loading, setLoading] = useState(true);  
    const [errorMessage, setErrorMessage] = useState("");
    const [showErrorPopup, setShowErrorPopup] = useState(false);  
    const [loanOfficer, setLoanOfficer] = useState(null);
    const [loanProcessor, setLoanProcessor] = useState(null);
    
    const handleSearch = (e, nmlsNumber) => {
        e.preventDefault();
        const query = nmlsNumber || searchText;
        if (query.trim()) {
        const url = `https://www.nmlsconsumeraccess.org/Home.aspx/SubSearch?searchText=${query}`;
        const width = 1200;
        const height = 800;
        const left = (window.screen.width - width) / 2;
        const top = (window.screen.height - height) / 2;
        window.open(url, '_blank', `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`);
        }
    };

    useEffect(() => {
        if (window.elli && window.elli.script && window.elli.script.guest) {
            window.elli.script.guest.create();
            initializeAuthObject();
        } else {
            console.warn("elli.script.guest is not available.");
            const errorCode = logError("GUEST_NOT_AVAILABLE");
            setErrorMessage(`Error Code: ${errorCode} - Guest functionality is not available.`);
            setShowErrorPopup(true);
        }
    }, []);
    
    const initializeAuthObject = async () => {
        if (!window.elli || !window.elli.script) {
            console.warn("elli.script is not available.");
            const errorCode = logError("AUTH_BLOCK_ERROR");
            setErrorMessage(`Error Code: ${errorCode} - Authentication failed.`);
            setShowErrorPopup(true);
            return;
        }

        try {
            const tpoAuthObject = await window.elli.script.getObject("auth");
                    
            try {
                const authCode = await tpoAuthObject.createAuthCode();
                const token = await getAccessToken(authCode);
                if (token) {
                    window.elli.script.getObject("loan").then(async function (loanObject) {
                        
                        const authCode = await tpoAuthObject.createAuthCode();
                    
                        loanObject.all().then(async function (loanData) {
                            console.log('Loan data ===', loanData.loan.id);
                            info("NMLS Verification loaded", { loanid: loanData.loan.id });
                            
                            fetchExternalUserDetails(authCode, loanData.loan.tpo.loId, loanData.loan.tpo.lpId);
                        });        
                    })
                }
                else{
                    const errorCode = logError("AUTH_BLOCK_ERROR");
                    redirectToErrorPage(`Error Code: ${errorCode} - Authentication failed.`);
                }
            } catch (error) {
                console.error("createAuthCode Error:", error);
                const errorCode = logError("AUTH_BLOCK_ERROR");
                setErrorMessage(`Error Code: ${errorCode} - Authentication failed.`);
                setShowErrorPopup(true);
                redirectToErrorPage(`Error Code: ${errorCode} - Authentication failed.`);
                setLoading(false);   

                logAppInsightError("Authentication failed", {
                    problemId: errorCode,
                    errorCode,
                    rawError: error,
                    errorMessage: `${errorCode} - Authentication failed."}`,
                    component: "verification"
                });
            }
        } catch (error) {
            console.error("Auth block Error:", error);
            const errorCode = logError("AUTH_CODE_ERROR");
            setErrorMessage(`Error Code: ${errorCode} - Unable to generate Auth Code.`);
            setShowErrorPopup(true);
            redirectToErrorPage(`Error Code: ${errorCode} - Unable to generate Auth Code.`);
            setLoading(false);   

            logAppInsightError("Unable to generate Auth Code", {
                problemId: errorCode,
                errorCode,
                rawError: error,
                errorMessage: `${errorCode} - Unable to generate Auth Code."}`,
                component: "verification"
            });
        }
    };

    const redirectToErrorPage = (message) => {
        window.location.href = `/exception?message=${encodeURIComponent(message)}&page=nmls`;    
    };

    const fetchExternalUserDetails = async (authCode, LOUserId, LPUserId) => {
        try {
            const response = await getLOLPUser(authCode, LOUserId, LPUserId);
            if (response) {
                
                const { loUser, lpUser } = response;
                if (loUser) {
                    setLoanOfficer({
                        name: `${loUser.firstName} ${loUser.lastName}` || 'N/A',
                        address: `${loUser.address}, ${loUser.city}, ${loUser.state}, ${loUser.zipCode}` || 'N/A',
                        nmls: loUser.nmlsId || 'N/A'
                    });
                }
     
                if (lpUser) {
                    setLoanProcessor({
                        name: `${lpUser.firstName} ${lpUser.lastName}` || 'N/A',
                        address: `${lpUser.address}, ${lpUser.city}, ${lpUser.state}, ${lpUser.zipCode}` || 'N/A',
                        nmls: lpUser.nmlsId || 'N/A'
                    });
                }                
            }
        } catch (error) {
            console.error("Error fetching external user details:", error);
            const errorCode = logError("USER_FETCH_ERROR");
            setErrorMessage(`Error Code: ${errorCode} - fetching external user details.`);
            setShowErrorPopup(true);

            logAppInsightError("fetching external user details", {
                problemId: errorCode,
                errorCode,
                rawError: error,
                errorMessage: `${errorCode} - fetching external user details."}`,
                component: "verification"
            });
        } finally {
            setLoading(false);
        }
    };
    
    if (loading) {
        return <Loading />;
    }
 
    return (
        <div className="min-h-screen flex flex-col items-center bg-gray-50 p-6">
            <div className="bg-white shadow-lg rounded-lg p-4 w-full max-w-2xl">
            
                <h2 className="text-center">
                    <span class="text-span-8">NMLS Verification</span>
                </h2>
                <form onSubmit={(e) => handleSearch(e, searchText)}>
                    <div className="mb-4 mt-6">                        
                        <input
                            id="nmlsId"
                            type="text"
                            placeholder="Enter a Name, Company, City, State, Zip Code, NMLS ID, and/or License Number"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            className="w-full p-2 border border-gray-300 rounded"
                                    />
                    </div>
                    <div className="flex justify-between">
                        <div className="text-left">
                        <p className="text-sm text-gray-700 mt-2 italic">Example: John Smith Rockville MD 20852 Bank of USA</p>
 
                        </div>
                    <div className="text-right">
                        <button type="submit" className="btn-secondary mt-2">Search</button>
                    </div>
                    </div>
                </form>
            </div>

            {/* Loan Officer and Loan Processor Section */}
            <div className="bg-white shadow-lg rounded-lg p-4 w-full max-w-2xl mt-6 border border-gray-300">
                <h3 className="text-lg font-semibold mb-4 text-gray-700">Loan Officer & Loan Processor</h3>
                <div className="grid grid-cols-2 gap-4">
                    {/* Loan Officer */}
                    <div className="border border-gray-300 p-4 rounded-md">
                        <h4 className="font-semibold text-blue-900">Loan Officer (LO)</h4>
                        <p className="text-sm mt-2">Name: <span className="font-medium">{loanOfficer.name || 'N/A'}</span></p>
                        <p className="text-sm">Address: <span className="font-medium">{loanOfficer.address || 'N/A'}</span></p>
                        <p className="text-sm">NMLS: <span className="font-medium">{loanOfficer.nmls || 'N/A'}</span></p>
                        <button className="mt-2 bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600 w-full"
                        onClick={(e) => handleSearch(e, loanOfficer.nmls)}>Verify</button>
                    </div>
                
                    {/* Loan Processor */}
                    <div className="border border-gray-300 p-4 rounded-md">
                        <h4 className="font-semibold text-blue-900">Loan Processor (LP)</h4>
                        <p className="text-sm mt-2">Name: <span className="font-medium">{loanProcessor.name || 'N/A'}</span></p>
                        <p className="text-sm">Address: <span className="font-medium">{loanProcessor.address || 'N/A'}</span></p>
                        <p className="text-sm">NMLS: <span className="font-medium">{loanProcessor.nmls || 'N/A'}</span></p>
                        <button className="mt-2 bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600 w-full"
                        onClick={(e) => handleSearch(e, loanProcessor.nmls)}>Verify</button>
                    </div>
                </div>
            </div>

            {showErrorPopup && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                        <h3 className="text-lg font-semibold text-red-600">Error</h3>
                        <p className="text-gray-700 mt-2">{errorMessage}</p>
                        <div className="mt-4 text-right">
                            <button
                                onClick={() => setShowErrorPopup(false)}
                                className="bg-red-500 text-white px-4 py-2 rounded">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
  );
};
 
export default NMLSVerification;